import BaseComponent from '../base/baseComponent';
import analyticsUtils from '../utilities/analyticsUtils';
export default class ConnectivityClick extends BaseComponent {
    constructor(element) {
        super(element);
        this._el.addEventListener('click', (e) => {
            var _a;
            e.preventDefault();
            const pid = ((_a = document.querySelector('.product-wrapper')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-pid')) || '';
            const url = this._el instanceof HTMLAnchorElement ? this._el.getAttribute('data-url') : null;
            const data = {
                'forcedPipeline': 'ConnectivityClick',
                'pid': pid
            };
            analyticsUtils.passThroughProcessor(data);
            setTimeout(() => {
                if (url) {
                    window.location.href = url;
                }
            }, 200);
        });
    }
}
